import React, {
    useState, useCallback, FormEvent, ChangeEvent,
} from 'react';

import { Input, MainTheme } from '@paretogroup/tess';
import RoundedButtonWithArrow from '@shared/components/inputs/buttons/RoundedButtonWithArrow';
import * as S from '../modal-strategy.styles';
import { ROUNDED_BUTTON_STYLE } from '../modal-strategy.styles';


type Props = {
    onSubmit: (params: {apiToken:string}) => void
    isSubmitting?: boolean
    initialData?: {apiToken: string}
}

export const TEXTS = {
    label: 'API Token',
    placeholder: 'Paste API Token here',
    button: 'Add Integration',
};

export const INPUT_TEST_ID = 'api-token-modal-input';

export const APITokenModal = ({
    onSubmit, isSubmitting = false, initialData = { apiToken: '' },
}: Props) => {
    const [integrationParams, setIntegrationParams] = useState(initialData);

    const handleSubmit = useCallback((e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        onSubmit(integrationParams);
    }, [integrationParams, onSubmit]);

    const handleAPITokenChange = (e: ChangeEvent<HTMLInputElement>) => {
        setIntegrationParams({ apiToken: e.target.value });
    };

    const classes = S.useStyles();

    return (
        <form onSubmit={handleSubmit}>
            <Input
                onChange={handleAPITokenChange}
                label={TEXTS.label}
                placeholder={TEXTS.placeholder}
                value={integrationParams.apiToken}
                data-testid={INPUT_TEST_ID}
                classes={classes}
            />

            <RoundedButtonWithArrow
                isDisabled={isSubmitting}
                isLoading={isSubmitting}
                label={TEXTS.button}
                styles={ROUNDED_BUTTON_STYLE}
                background={null}
                color={MainTheme.colors.white}
                onClick={null}
            />
        </form>
    );
};
